import { discoveryQueryKeys as e } from "./useDiscoveryQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { discoverApi as n } from "@maat/api-main";
//#region src/discovery/useSimilarSlotListingsQuery.ts
var r = (r, i = {}) => t({
	queryKey: e.similar(r),
	queryFn: () => n.getSimilar(r),
	enabled: !!r && i.enabled !== !1
});
//#endregion
export { r as useSimilarSlotListingsQuery };
